import { createContext, useContext } from "react";

// 도트(픽셀아트) 모드 — 홈 대시보드 차트/화면을 레트로 픽셀 스타일로 렌더
export type DotScope = "charts" | "full";

export interface DotModeState {
  enabled: boolean;
  /** charts = 차트만 도트화 / full = 화면 전체 픽셀 폰트까지 */
  scope: DotScope;
}

export const DEFAULT_DOT_MODE: DotModeState = { enabled: false, scope: "charts" };

export const DotModeContext = createContext<DotModeState>(DEFAULT_DOT_MODE);

/** 차트 컴포넌트에서 현재 도트 모드 상태를 읽는다. */
export const useDotMode = () => useContext(DotModeContext);

export const DOT_MODE_STORAGE_KEY = "rmc-dashboard-dotmode";
